import Vue from 'vue'
const getters = {
	isVerticalScreen: state => state.app.isVerticalScreen,
	scaleRate: state => state.app.scaleRate
}
export default getters